import React from 'react';

import { LinkToDebrief, LinkToHome } from 'ff/debrief/router';
import { useRouteContext } from 'ff/debrief/hooks';
import TracklogMapControls from 'ff/debrief/components/map/TracklogMapControls';
import Sidebar from 'ff/debrief/components/sidebar';
import FlightDetails from 'ff/debrief/components/details';
import ErrorBar from 'ff/debrief/components/ErrorBar';
import MapAreaGrid from 'ff/debrief/layouts/MapAreaGrid';

export const pathString = '/:tracklogId?';

const HomeRoute = () => {
    useRouteContext({
        returnLink: LinkToHome,
        debriefLink: LinkToDebrief,
        page: 'TrackListView',
    });

    return (
        <MapAreaGrid>
            <TracklogMapControls />
            <Sidebar />
            <FlightDetails />
            <ErrorBar />
        </MapAreaGrid>
    );
};

export default HomeRoute;
